var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Pricing.Audit"),
        width: "1000px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "price-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "price-dialog-header" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { no: "onOK", type: "primary" },
                on: { click: _vm.onOK }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.CONFIRM")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Back")))]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticStyle: { margin: "10px" } },
        [
          _c("el-checkbox", {
            attrs: { no: "tier1", label: "Tier 1", disabled: true, checked: "" }
          }),
          _c("el-checkbox", {
            attrs: { no: "tier2", label: "Tier 2", disabled: true, checked: "" }
          }),
          _c("el-checkbox", {
            attrs: { no: "tier3", label: "Tier 3", disabled: true, checked: "" }
          })
        ],
        1
      ),
      _c("markup-air-data-grid", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          "row-data": _vm.rowData,
          editable: false,
          "grid-options": _vm.gridOptions
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }